import { Sparkle } from "@/components/shared/Motifs";

// Text-based wordmark rendered in the brand serif for crispness at any size.
// variant: "dark" for light backgrounds (navy text), "light" for dark backgrounds (cream text).
export function Logo({ variant = "dark", showTagline = true, className = "", size = "md" }) {
  const isLight = variant === "light";
  const sizes = {
    sm: { name: "text-xl", tag: "text-[9px]" },
    md: { name: "text-2xl", tag: "text-[10px]" },
    lg: { name: "text-3xl", tag: "text-xs" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex flex-col leading-none ${className}`}>
      <div className="flex items-start gap-1">
        <span
          className={`font-heading font-semibold tracking-tight ${s.name} ${
            isLight ? "text-cream" : "text-navy"
          }`}
        >
          Shubh<span className={isLight ? "text-cream" : "text-navy"}>Samay</span>
        </span>
        <Sparkle className="text-gold mt-0.5" size={12} />
      </div>
      {showTagline && (
        <span
          className={`font-sans font-medium uppercase tracking-[0.22em] mt-1 ${s.tag} text-gold`}
        >
          Safalta Ka Sahi Samay
        </span>
      )}
    </div>
  );
}
